(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  /**
   * Centers the "Best Seller" label above the bundle image.
   * Positions it horizontally centered above the bundle card image.
   */
  function centerBundleLabel() {
    const label = document.querySelector('.kaching-bundles__bar-label');
    if (!label) return;
    
    // Find the bundle bar that contains the label
    const bundleBar = label.closest('.kaching-bundles__bar');
    if (!bundleBar) return;
    
    // Find the bundle image element
    const bundleImage = bundleBar.querySelector('.kaching-bundles__bar-image');
    const cardContainer = bundleBar.querySelector('.kaching-bundles__bar-container') || 
                         bundleBar.querySelector('.kaching-bundles__bar-main') ||
                         bundleBar;
    
    if (!cardContainer) return;
    
    // Get bounding rectangles
    const imageRect = bundleImage ? bundleImage.getBoundingClientRect() : null;
    const cardRect = cardContainer.getBoundingClientRect();
    const labelRect = label.getBoundingClientRect();
    const barRect = bundleBar.getBoundingClientRect();
    
    // Calculate center position - use image if available, otherwise use card center
    let centerX;
    if (imageRect) {
      // Center above the image
      centerX = imageRect.left - barRect.left + (imageRect.width / 2);
    } else {
      // Fallback to card center
      centerX = cardRect.left - barRect.left + (cardRect.width / 2);
    }
    
    // Position label at center, accounting for its own width
    const labelLeft = centerX - (labelRect.width / 2);
    
    // Apply the position
    label.style.left = `${labelLeft}px`;
    label.style.transform = 'translateX(0)';
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(centerBundleLabel, 100);
    });
  } else {
    setTimeout(centerBundleLabel, 100);
  }
  
  // Re-center on window resize and variant changes
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(centerBundleLabel, 100);
  });
  
  // Also check when variants change (Kaching updates)
  document.addEventListener('variants-changed', () => {
    setTimeout(centerBundleLabel, 100);
  });

  } catch(e) { console.error(e); }
})();
})();
